export function noop(..._args: any[]): void {
  // Ne fait rien
}
